import React from "react";
import { Box } from "@mui/material";
import { AUTH_SUCCESS, AUTH_ERROR } from "../../../theme/appTheme";

const STATUS_STYLES = {
  pending: { dot: "#B45309", label: "Pending" },
  approved: { dot: AUTH_SUCCESS, label: "Approved" },
  rejected: { dot: AUTH_ERROR, label: "Rejected" },
  revoked: { dot: "#EA580C", label: "Revoked" },
};

// Small dot+label pill, same shape as StatusPill.js but recolored per
// application status instead of that component's fixed LIVE/OFFLINE tones.
export default function ApplicationStatusBadge({ status }) {
  const style = STATUS_STYLES[status] || STATUS_STYLES.pending;

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        background: "#EDEDED",
        color: "#4b5563",
        fontSize: "11px",
        fontWeight: 600,
        px: "10px",
        py: "4px",
        borderRadius: "999px",
        flexShrink: 0,
        whiteSpace: "nowrap",
      }}
    >
      <Box
        component="span"
        sx={{ width: 6, height: 6, borderRadius: "50%", background: style.dot, flexShrink: 0 }}
      />
      {style.label}
    </Box>
  );
}
